import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { loadRuntimeConfig } from './config';
import './assets/main.css';

async function bootstrap() {
  await loadRuntimeConfig();

  const app = createApp(App);
  app.use(createPinia());
  app.use(router);
  app.mount('#app');
}

bootstrap().catch((err: unknown) => {
  console.error('Failed to initialise application:', err);
  document.body.innerHTML =
    '<div style="padding:2rem;color:red;">Failed to load application configuration. Please refresh the page.</div>';
});
